import useAppDispatch from '@/hooks/useAppDispatch'
import useAppSelector from '@/hooks/useAppSelector'
import {
  hideLogHistoricalReferralModal,
  selectLogHistoricalReferralState,
  showLogHistoricalReferralModal,
} from '@/redux/slices/logHistoricalReferral'

export function useLogHistoricalReferralModal() {
  const isOpen = useAppSelector(selectLogHistoricalReferralState).isModalOpen
  const dispatch = useAppDispatch()

  return {
    isShowing: isOpen,
    show: () => dispatch(showLogHistoricalReferralModal()),
    hide: () => dispatch(hideLogHistoricalReferralModal()),
  }
}
